import _ from 'lodash';
import { BRANCH_FIELDS, SCHOOL_FIELDS } from '../../constants/admin.schools.constants';
import { schools } from '../bff.api';
import responseValidators from '../response.validators';

const _gcpElementToOption = (el) => ({
  label: _.get(el, 'spoEntityData.shadow.name') || _.get(el, 'spoEntityData.agodi.name') || 'Onbekend',
  value: _.get(el, 'id', '')
});

const _updateSchoolBody = (data) => {
  const result = _.pick(
    data,
    SCHOOL_FIELDS.filter((f) => f.field !== 'isVisible').map((f) => f.field)
  );

  return result;
};

const _createSchoolBody = (data) => {
  return _.pick(
    data,
    SCHOOL_FIELDS.filter((f) => f.field !== 'isVisible').map((f) => f.field)
  );
};

const _updateBranchBody = (data) => {
  return _.pick(
    data,
    BRANCH_FIELDS.filter((f) => f.field !== 'isVisible').map((f) => f.field)
  );
};

const _createBranchBody = (data) => {
  return _.pick(
    data,
    BRANCH_FIELDS.filter((f) => f.field !== 'isVisible').map((f) => f.field)
  );
};

const _updateAgodiBranchBody = (data) => ({ name: data?.name });

const _handleError = (err, onError) => {
  if (onError) {
    onError(err.message);
  }
};

const search = async (query, options = {}) => {
  return schools
    .search({ search: query })
    .then((resp) => {
      responseValidators.searchAdminSchools(resp);
      if (options.onSuccess) {
        options.onSuccess(_.get(resp, 'json._embedded.resourceList'));
      }
    })
    .catch((err) => _handleError(err, options.onError));
};

const get = async (netId, managementId, communityId, schoolId, options = {}) => {
  return schools
    .getSchool(netId, managementId, communityId, schoolId)
    .then((resp) => {
      responseValidators.getSchool(resp);
      if (options.onSuccess) {
        options.onSuccess(resp.json);
      }
    })
    .catch((err) => _handleError(err, options.onError));
};

const getBranch = async (netId, managementId, communityId, schoolId, branchId, options = {}) => {
  return schools
    .getBranch(netId, managementId, communityId, schoolId, branchId)
    .then((resp) => {
      responseValidators.getBranch(resp);
      if (options.onSuccess) {
        options.onSuccess(resp.json);
      }
    })
    .catch((err) => _handleError(err, options.onError));
};

const add = async (netId, managementId, communityId, data, options = {}) => {
  return schools
    .add(netId, managementId, communityId, _createSchoolBody(data))
    .then((resp) => {
      responseValidators.addSchool(resp);
      if (options.onSuccess) {
        options.onSuccess(resp.json);
      }
    })
    .catch((err) => _handleError(err, options.onError));
};

const addBranch = async (netId, managementId, communityId, schoolId, data, options = {}) => {
  return schools
    .addBranch(netId, managementId, communityId, schoolId, _createBranchBody(data))
    .then((resp) => {
      responseValidators.addBranch(resp);
      if (options.onSuccess) {
        options.onSuccess(resp.json);
      }
    })
    .catch((err) => _handleError(err, options.onError));
};

const update = async (netId, managementId, communityId, schoolId, data, options = {}) => {
  return schools
    .update(netId, managementId, communityId, schoolId, _updateSchoolBody(data))
    .then((resp) => {
      responseValidators.updateSchool(resp);
      if (options.onSuccess) {
        options.onSuccess(resp);
      }
    })
    .catch((err) => _handleError(err, options.onError));
};

const updateBranch = async (netId, managementId, communityId, schoolId, branchId, data, options = {}) => {
  return schools
    .updateBranch(netId, managementId, communityId, schoolId, branchId, _updateBranchBody(data))
    .then((resp) => {
      responseValidators.updateBranch(resp);
      if (options.onSuccess) {
        options.onSuccess(resp);
      }
    })
    .catch((err) => _handleError(err, options.onError));
};

const remove = async (netId, managementId, communityId, schoolId, options = {}) => {
  return schools
    .remove(netId, managementId, communityId, schoolId)
    .then((resp) => {
      responseValidators.deleteSchool(resp);
      if (options.onSuccess) {
        options.onSuccess(resp);
      }
    })
    .catch((err) => _handleError(err, options.onError));
};

const removeBranch = async (netId, managementId, communityId, schoolId, branchId, options = {}) => {
  return schools
    .removeBranch(netId, managementId, communityId, schoolId, branchId)
    .then((resp) => {
      responseValidators.deleteBranch(resp);
      if (options.onSuccess) {
        options.onSuccess(resp);
      }
    })
    .catch((err) => _handleError(err, options.onError));
};

const setSchoolVisible = async (netId, managementId, communityId, schoolId, options) => {
  return schools
    .setSchoolVisible(netId, managementId, communityId, schoolId)
    .then((resp) => {
      responseValidators.setSchoolVisible(resp);
      if (options.onSuccess) {
        options.onSuccess(resp);
      }
    })
    .catch((err) => _handleError(err, options.onError));
};

const setSchoolInvisible = async (netId, managementId, communityId, schoolId, options) => {
  return schools
    .setSchoolInvisible(netId, managementId, communityId, schoolId)
    .then((resp) => {
      responseValidators.setSchoolInvisible(resp);
      if (options.onSuccess) {
        options.onSuccess(resp);
      }
    })
    .catch((err) => _handleError(err, options.onError));
};

const setBranchVisible = async (netId, managementId, communityId, schoolId, branchId, options) => {
  return schools
    .setBranchVisible(netId, managementId, communityId, schoolId, branchId)
    .then((resp) => {
      responseValidators.setBranchVisible(resp);
      if (options.onSuccess) {
        options.onSuccess(resp);
      }
    })
    .catch((err) => _handleError(err, options.onError));
};

const setBranchInvisible = async (netId, managementId, communityId, schoolId, branchId, options) => {
  return schools
    .setBranchInvisible(netId, managementId, communityId, schoolId, branchId)
    .then((resp) => {
      responseValidators.setBranchInvisible(resp);
      if (options.onSuccess) {
        options.onSuccess(resp);
      }
    })
    .catch((err) => _handleError(err, options.onError));
};

const updateAgodiBranch = async (
  netId,
  managementId,
  communityId,
  schoolId,
  branchId,
  agodiBranchId,
  data,
  options = {}
) => {
  return schools
    .updateAgodiBranch(
      netId,
      managementId,
      communityId,
      schoolId,
      branchId,
      agodiBranchId,
      _updateAgodiBranchBody(data)
    )
    .then((resp) => {
      responseValidators.updateAgodiBranch(resp);
      if (options.onSuccess) {
        options.onSuccess(resp);
      }
    })
    .catch((err) => _handleError(err, options.onError));
};

const getSchoolNetsOptions = async (options) => {
  return schools
    .getNets({ page: 1, size: 999, sort: 'name' })
    .then((resp) => {
      responseValidators.generic(resp)
      if (options.onSuccess) {
        options.onSuccess(_.get(resp, 'json._embedded.schoolNets.result').map(_gcpElementToOption));
      }
    })
    .catch((err) => _handleError(err, options.onError));
};

const getAllSchools = async (options) => {
  return schools
    .getAll()
    .then((resp) => {
      responseValidators.getAllSchools(resp)
      if (options.onSuccess) {
        options.onSuccess(_.get(resp, 'json._embedded.resourceList'));
      }
    })
    .catch((err) => _handleError(err, options.onError));
};

const getAllManagements = async (options) => {
  return schools
    .getAllManagements()
    .then((resp) => {
      if (options.onSuccess) {
        options.onSuccess(_.get(resp, 'json._embedded.resourceList'));
      }
    })
    .catch((error) => _handleError(error));
};

const getSchoolManagement = async (netId, managementId, options) => {
  return schools
    .getManagement(netId, managementId)
    .then((resp) => {
      if (options.onSuccess) {
        options.onSuccess(_.get(resp, 'json._embedded.schoolManagements.result').map(_gcpElementToOption));
      }
    })
    .catch((err) => _handleError(err, options.onError));
};

const getAllCommunities = async (options) => {
  return schools
    .getAllCommunities()
    .then((resp) => {
      if (options.onSuccess) {
        options.onSuccess(_.get(resp, 'json._embedded.resourceList'));
      }
    })
    .catch((err) => _handleError(err, options.onError));
};

const adminSchoolsService = {
  search,
  get,
  add,
  addBranch,
  update,
  updateBranch,
  remove,
  removeBranch,
  getBranch,
  updateAgodiBranch,
  setSchoolVisible,
  setSchoolInvisible,
  setBranchVisible,
  setBranchInvisible,
  getSchoolNetsOptions,
  getAllSchools,
  getAllManagements,
  getAllCommunities,
  getSchoolManagement
};

export default adminSchoolsService;
